<template>
  <v-slide-group
    v-if="items.length"
    v-model="subcategoriesSelecteds"
    class="mt-6 categories"
    multiple
    show-arrows
  >
    <v-slide-item
      v-for="({ text, value }, keyItems) in items"
      :key="keyItems"
      :value="value"
      v-slot="{ active, toggle }"
    >
      <v-btn
        @click="toggle"
        class="text-body-1 text-none font-weight-medium rounded-lg"
        color="secondary lighten-4"
        :outlined="!active"
        depressed
      >
        {{ text }}
      </v-btn>
    </v-slide-item>
  </v-slide-group>
</template>

<script>
import { mixin } from "./mixin";
import { productFilter } from "../../../utils/productFilter";

const _config = {
  mod: "products-subcategories",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod)
        .list.filter(({ category }) => category === this.categoryId)
        .map(({ id, title }) => ({
          text: title,
          value: Number(id),
        }));
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  mixins: [mixin, productFilter],
};
</script>

<style lang="scss" scoped>
.categories::v-deep {
  .v-slide-group__content {
    justify-content: center;
    gap: 8px;
  }
}
</style>
